import React, { Dispatch, SetStateAction, useMemo } from "react";
import { Box, Grid } from "@mui/material";
import ButtonSwitcher from "../../components/ButtonSwitcher/ButtonSwitcher";

interface InlineVariablesProps {
  handleChangeVariable: any;
  inlineVariables: any;
  isReadOnly: boolean;
  isDisplayUsedVariable?: boolean;
  showVariables?: string;
  setShowVariables?: Dispatch<SetStateAction<string>>;
}

const InlineVariables: React.FC<InlineVariablesProps> = ({
  handleChangeVariable,
  inlineVariables,
  isReadOnly,
  isDisplayUsedVariable = false,
  showVariables = "used",
  setShowVariables,
}) => {
  const handleVariableTypeChange = (type: string) => {
    setShowVariables &&
      setShowVariables(type === "usedvariables" ? "used" : "unused");
  };

  const filteredVars = useMemo(() => {
    if (!inlineVariables?.inline_variables) return {};
    const filteredInlineVariables = Object.fromEntries(
      Object.entries(inlineVariables.inline_variables).filter(([key]) => {
        const isUsed =
          inlineVariables?.used_variables?.length > 0 &&
          inlineVariables.used_variables.includes(key);
        return showVariables === "used" ? isUsed : !isUsed;
      })
    );
    return {
      inline_variables: filteredInlineVariables,
    };
  }, [inlineVariables, showVariables]);

  return isDisplayUsedVariable ? (
    <>
      <Grid item xs={12}>
        <Box className="position-relative" sx={{ marginBottom: "16px" }}>
          <ButtonSwitcher
            buttonsName={["Used Variables", "Unused Variables"]}
            selectedPlan={
              showVariables === "used" ? "Used Variables" : "Unused Variables"
            }
            setSelectedPlan={handleVariableTypeChange}
            className="variables-switcher"
          />
        </Box>
      </Grid>

      <table className="inline-variables-table">
        <tbody>
          {filteredVars?.inline_variables &&
          Object.keys(filteredVars?.inline_variables).length > 0 ? (
            Object.keys(filteredVars?.inline_variables).map(
              (key: string, index: number) => {
                return (
                  <tr key={key}>
                    <td>
                      <div className="inner-column">
                        <div className="label">
                          <strong>{key}</strong>
                          <span className="required-asterisk">*</span>:
                        </div>
                        <input
                          className={`form-control-1 ${
                            isReadOnly ? "read-only" : ""
                          }`}
                          value={String(
                            filteredVars?.inline_variables?.[key] ?? ""
                          )}
                          name={key}
                          title={String(
                            filteredVars?.inline_variables?.[key] ?? ""
                          )}
                          onChange={(event) =>
                            handleChangeVariable(event, key + index)
                          }
                          readOnly={isReadOnly}
                        />
                      </div>
                    </td>
                  </tr>
                );
              }
            )
          ) : (
            <tr>
              <td className="text-center">No variables found</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  ) : (
    <table className="inline-variables-table">
      <tbody>
        {inlineVariables &&
          Object.keys(inlineVariables).map((key: string, index: number) => {
            return (
              <tr key={key}>
                <td>
                  <div className="inner-column">
                    <div className="label">
                      <strong>{key}</strong>
                      <span className="required-asterisk">*</span>:
                    </div>
                    <input
                      className={`form-control-1 ${
                        isReadOnly ? "read-only" : ""
                      }`}
                      value={String(inlineVariables[key] ?? "")}
                      name={key}
                      title={String(inlineVariables[key] ?? "")}
                      onChange={(event) =>
                        handleChangeVariable(event, key + index)
                      }
                      readOnly={isReadOnly}
                    />
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export default React.memo(InlineVariables);
